import { clsx } from 'clsx';

import styles from './Separator.module.scss';

import { IClassname } from '../../model/classname';

export const Separator = ({ className }: IClassname) => {
  return <div className={clsx(styles.separator, className)}></div>;
};
